var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, CardFooter, } from 'grommet';
export var PlanFooter = function (_a) {
    var _b = _a.highlight, highlight = _b === void 0 ? false : _b, _c = _a.buttonProps, buttonProps = _c === void 0 ? {} : _c, rest = __rest(_a, ["highlight", "buttonProps"]);
    return (_jsx(CardFooter, __assign({ justify: "center", background: highlight ? "brand" : "background-front" }, rest, { children: _jsx(Button, __assign({ primary: true, color: highlight ? "status-error" : "brand", label: "Start Now", alignSelf: "stretch", margin: { bottom: "medium" } }, buttonProps)) })));
};
PlanFooter.defaultProps = {
    highlight: false,
    buttonProps: {},
};
//# sourceMappingURL=PlanFooter.js.map